import { useDataProvider } from "react-admin";
import { getEnvironmentConfig, cockpitDataProvider } from "@airborne/react-admin";
import * as config from "./config";
import { RequestStatus } from "./Enums/RequestStatus";
import { ConfigureAxios } from "./ConfigureAxios";

const envConfig = getEnvironmentConfig(config);

const dataProvider = cockpitDataProvider(envConfig.apiBaseUrl, {
  axios: ConfigureAxios({ baseURL: envConfig.apiBaseUrl }),
});
const { http } = dataProvider;
const appDataProvider = {
  ...dataProvider,

  post(apiName, request) {
    return http.post(dataProvider.baseUrl + "/" + apiName, request);
  },

  get(apiName, config?) {
    return http.get(dataProvider.baseUrl + "/" + apiName, config);
  },

  put(apiName, request?, options?) {
    return http.put(dataProvider.baseUrl + "/" + apiName, request, options);
  },

  async updateMultipleNote(item) {
    const data = await http.put(dataProvider.baseUrl + "/componentsentegrations/multiple/reportnote", item);
    return data;
  },

  async updateRequestSpt(item) {
    const data = await http.put(dataProvider.baseUrl + "/requestSpts", item);
    return data;
  },

  async updateRequestOrder(item) {
    if (item.requestedDeliveryDate === null) item.requestedDeliveryDate = new Date();
    return http.put(dataProvider.baseUrl + "/requestorders", item);
  },

  async updatePreviousStep(item) {
    if (item.requestedDeliveryDate === null) item.requestedDeliveryDate = new Date();
    return http.put(dataProvider.baseUrl + "/requestorders/updatepreviousstep", item);
  },

  async postRequestOrder(item) {
    const data = await http.post(dataProvider.baseUrl + "/requestorders", item);
    return data;
  },

  async postLeaseComponent(item) {
    const data = await http.post(dataProvider.baseUrl + "/leasecomponents", item);
    return data;
  },

  async postPbhWaitingResponseRemark(item) {
    const data = await http.post(dataProvider.baseUrl + "/pbhwaitingresponseremarks", item);
    return data;
  },

  async postPbhWaitingResponse(item) {
    const data = await http.post(dataProvider.baseUrl + "/pbhwaitingresponses", item);
    return data;
  },

  async postPbhWaitingResponseFileRelation(item, props) {
    const {
      data: { url, objectKey },
    } = await http.put(dataProvider.baseUrl + `/minio/${item.fileName}`);
    await http.put(url, item.file, {
      headers: { "Content-Type": item.file.type },
    });
    const createFile = { id: 0, name: item.fileName, objectKey: objectKey };
    const postData = { ...props.object, pbhWaitingResponseId: item.pbhWaitingResponseId, file: createFile };
    return http.post(dataProvider.baseUrl + "/" + props.object.source, postData);
  },

  async putPbhWaitingResponse(item) {
    const data = await http.put(dataProvider.baseUrl + "/pbhwaitingresponses", item);
    return data;
  },

  async putLeaseComponent(item) {
    const data = await http.put(dataProvider.baseUrl + "/leasecomponents", item);
    return data;
  },

  async postUmsUser(item) {
    const data = await http.post(dataProvider.baseUrl + "/umsusers", item);
    return data;
  },

  async putRequestOrder(item) {
    const data = await http.put(dataProvider.baseUrl + "/requestorders", item);
    return data;
  },

  async postRequestServiceable(item) {
    const data = await http.post(dataProvider.baseUrl + "/requestserviceables", item);
    return data;
  },
  async putRequestServiceable(item) {
    const data = await http.put(dataProvider.baseUrl + "/requestserviceables", item);
    return data;
  },
  async postPbhRequestServiceable(item) {
    const data = await http.post(dataProvider.baseUrl + "/pbhrequestserviceables", item);
    return data;
  },
  async putPbhRequestServiceable(item) {
    const data = await http.put(dataProvider.baseUrl + "/pbhrequestserviceables", item);
    return data;
  },

  async postRequestOrderQuarantineProcess(item) {
    const data = await http.post(dataProvider.baseUrl + "/requestorders/quarantine", item);
    return data;
  },

  async postRequestUnserviceable(item) {
    const data = await http.post(dataProvider.baseUrl + "/requestunserviceables", item);
    return data;
  },

  async putRequestUnserviceable(item) {
    const data = await http.put(dataProvider.baseUrl + "/requestunserviceables", item);
    return data;
  },
  async postPbhRequestUnserviceable(item) {
    const data = await http.post(dataProvider.baseUrl + "/pbhrequestunserviceables", item);
    return data;
  },
  async postExperiencesAddBulk(item) {
    const data = await http.post(dataProvider.baseUrl + "/experiences/bulkcreate", item);
    return data;
  },
  async putPbhRequestUnserviceable(item) {
    const data = await http.put(dataProvider.baseUrl + "/pbhrequestunserviceables", item);
    return data;
  },
  async postRequestAlternatePn(item) {
    const data = await http.post(dataProvider.baseUrl + "/requestalternatepns", item);
    return data;
  },
  async putRequestAlternatePn(item) {
    const data = await http.put(dataProvider.baseUrl + "/requestalternatepns", item);
    return data;
  },
  async postBulkRequestAlternatePn(item) {
    const data = await http.post(dataProvider.baseUrl + "/requestalternatepns/createbulk", item);
    return data;
  },
  async postRejectAllRequestAlternatePn(item) {
    const data = await http.post(dataProvider.baseUrl + "/requestalternatepns/rejectall", item);
    return data;
  },

  async postPbhRequestAlternatePn(item) {
    const data = await http.post(dataProvider.baseUrl + "/pbhrequestalternatepns", item);
    return data;
  },
  async putPbhRequestAlternatePn(item) {
    const data = await http.put(dataProvider.baseUrl + "/pbhrequestalternatepns", item);
    return data;
  },
  async postBulkPbhRequestAlternatePn(item) {
    const data = await http.post(dataProvider.baseUrl + "/pbhrequestalternatepns/createbulk", item);
    return data;
  },
  async postRejectAllPbhRequestAlternatePn(item) {
    const data = await http.post(dataProvider.baseUrl + "/pbhrequestalternatepns/rejectall", item);
    return data;
  },

  async putAircraftUtilization(item) {
    const data = await http.put(dataProvider.baseUrl + "/aircraftutilizations", item);
    return data;
  },

  async AircraftUtilizationBulkApprove(item) {
    const data = await http.post(dataProvider.baseUrl + "/aircraftutilizations/bulkapprove", item);
    return data;
  },

  async postCoreInfoRequest(item) {
    const data = await http.post(dataProvider.baseUrl + "/coreinforequests", item);
    return data;
  },

  async putCoreInfoRequest(item) {
    const data = await http.put(dataProvider.baseUrl + "/coreinforequests", item);
    return data;
  },

  async postQuarantine(item) {
    const data = await http.post(dataProvider.baseUrl + "/quarantines", item);
    return data;
  },

  async putQuarantine(item) {
    const data = await http.put(dataProvider.baseUrl + "/quarantines", item);
    return data;
  },
  async putQuarantineDetail(item) {
    const data = await http.put(dataProvider.baseUrl + "/quarantinedetails", item);
    return data;
  },

  async postRequestServiceableRedelivery(item) {
    const data = await http.post(dataProvider.baseUrl + "/requestredeliverys", item);
    return data;
  },

  async putRequestServiceableRedelivery(item) {
    const data = await http.put(dataProvider.baseUrl + "/requestredeliverys", item);
    return data;
  },

  async postRequestArrivalInfo(item) {
    const data = await http.post(dataProvider.baseUrl + "/requestarrivalinfos", item);
    return data;
  },

  async putRequestArrivalInfo(item) {
    const data = await http.put(dataProvider.baseUrl + "/requestarrivalinfos", item);
    return data;
  },
  async postRequestSpt(item) {
    const data = await http.post(dataProvider.baseUrl + "/requestspts", item);
    return data;
  },

  async postMailSchema(item) {
    const data = await http.post(dataProvider.baseUrl + "/mailschemas", item);
    return data;
  },

  async postMailManagement(item) {
    const data = await http.post(dataProvider.baseUrl + "/mailmanagements", item);
    return data;
  },

  async postFlightRadarFetch(item: { periodYear: number; periodMonth: number }) {
    const data = await http.post(dataProvider.baseUrl + "/aircraftutilizations/fetchfr", item);
    return data;
  },

  async postFrBulkFetchEnqueue(item: { startYear: number; startMonth: number; endYear: number; endMonth: number }) {
    const data = await http.post(dataProvider.baseUrl + "/frbulkfetchrequests/enqueue", item);
    return data;
  },

  async getFrBulkFetchRequests(requestedYear: number, requestedMonth: number) {
    const data = await dataProvider.getList("frbulkfetchrequests", {
      pagination: { page: 1, perPage: 99999 },
      sort: { field: "targetYear", order: "ASC" },
      filter: { requestedYear__eq: requestedYear, requestedMonth__eq: requestedMonth },
    });
    return data;
  },

  async getAiReliabilityCustomerScore(ownerCode: string) {
    const data = await http.get(dataProvider.baseUrl + "/aircraftutilizations/ai-reliability/score/" + ownerCode);
    return data;
  },

  async getAiReliabilityAircraftScores(ownerCode: string) {
    const data = await http.get(
      dataProvider.baseUrl + "/aircraftutilizations/ai-reliability/score/" + ownerCode + "/aircrafts"
    );
    return data;
  },

  async getAiReliabilityReportData(ownerCode: string) {
    const data = await http.get(dataProvider.baseUrl + "/aircraftutilizations/ai-reliability/report-data/" + ownerCode);
    return data;
  },

  async postAiReliabilityCalculate(ownerCode: string) {
    const data = await http.post(
      dataProvider.baseUrl + "/aircraftutilizations/ai-reliability/calculate/" + ownerCode,
      {}
    );
    return data;
  },

  async putRequestSpt(item) {
    const data = await http.put(dataProvider.baseUrl + "/requestspts", item);
    return data;
  },

  async asyncTriggerInitialReceiving(item) {
    if (item.requestedDeliveryDate === null) item.requestedDeliveryDate = new Date();
    await http.post(dataProvider.baseUrl + "/requestorders/initialreceiving", item);
  },

  async getRequestInfoByEnum(requestStatus: RequestStatus) {
    await dataProvider.getOne("requeststatusinfo/reference", {
      id: requestStatus,
    });
  },
  async getRequestInfoList() {
    const data = await dataProvider.getList("requeststatusinfos", {
      pagination: { page: 1, perPage: 500 },
      sort: { field: "requestStatus", order: "ASC" },
      filter: {},
    });
    return data;
  },
  async getCustomerList() {
    const data = await dataProvider.getList("customers", {
      pagination: { page: 1, perPage: 99999 },
      sort: { field: "id", order: "ASC" },
      filter: {},
    });
    return data;
  },
  async getPnHardTimeFromPn(pn) {
    const data = await dataProvider.getList("vwpnhardtimes", {
      pagination: { page: 1, perPage: 1 },
      sort: { field: "id", order: "ASC" },
      filter: { pn__eq: pn },
    });
    return data;
  },
  async getPnMasterByPn(pn) {
    return await dataProvider.getOne("vwpnmasters", {
      id: pn,
    });
  },
  async getShippingAddressByAirportAndCustomer(airportCode, customerId) {
    const data = await dataProvider.getList("shippingaddresss", {
      pagination: { page: 1, perPage: 1 },
      sort: { field: "id", order: "DESC" },
      filter: { airportCode__eq: airportCode, customerId__eq: customerId },
    });
    return data;
  },
  async getListConsignments(mpn, contractNumber) {
    const data = await dataProvider.getList("cdmpoolconsignments", {
      pagination: { page: 1, perPage: 500 },
      sort: { field: "id", order: "DESC" },
      filter:
        mpn == null
          ? { mpn__neq: mpn, contractNumber__eq: contractNumber }
          : { mpn__eq: mpn, contractNumber__eq: contractNumber },
    });
    return data;
  },
  async createPbhRequestOrder(item) {
    return await http.post(dataProvider.baseUrl + "/pbhrequestorders", item);
  },
  async updatePbhRequestOrder(item) {
    return await http.put(dataProvider.baseUrl + "/pbhrequestorders", item);
  },
  async createPbhRequestRemarks(item) {
    return await http.post(dataProvider.baseUrl + "/pbhrequestremarks", item);
  },
  async createPbhStatusUpdate(item) {
    return await http.post(dataProvider.baseUrl + "/pbhstatusupdates", item);
  },
  // async createBulkRequestWorkFlow(item) {
  //   return await http.post(dataProvider.baseUrl + '/requestworkflows/bulkinsert', item)
  // },
  // async getListRequestWorkFlow() {
  //   const data = await dataProvider.getList('requestworkflows', {
  //     pagination: { page: 1, perPage: 500 },
  //     sort: { field: 'id', order: 'DESC' },
  //     filter: { isDeleted__eq: false }
  //   })
  //   return data
  // },
  async getNewRequestData(acReg) {
    const data = await http.get(dataProvider.baseUrl + "/cdmnewrequest/" + acReg);
    return data;
  },
  async getRequestHistoryList(requestId) {
    const data = await dataProvider.getList("requesthistorys", {
      pagination: { page: 1, perPage: 1000 },
      sort: { field: "createdDate", order: "ASC" },
      filter: { requestId__eq: requestId },
    });
    return data;
  },
  async getLocationList() {
    const data = await dataProvider.getList("cdmlocations", {
      pagination: { page: 1, perPage: 9999 },
      sort: { field: "id", order: "ASC" },
      filter: {},
    });
    return data;
  },
  async getRequestList(objectKey) {
    const data = await http.get(dataProvider.baseUrl + "/requestorders?" + objectKey);
    return data;
  },
  async getRequestTablesHistoryList(source, id) {
    const data = await http.get(dataProvider.baseUrl + "/" + source + "/" + id);
    return data;
  },
  async getCoreInfoRequestHistoryList(id) {
    const data = await http.get(dataProvider.baseUrl + "/requesttableshistory/coreinforequest?id=" + id);
    return data;
  },
  async getPbhUnserviceableRequestHistoryList(coreInfoRequestId) {
    const data = await http.get(
      dataProvider.baseUrl + "/requesttableshistory/pbhunserviceable?coreInfoRequestId=" + coreInfoRequestId
    );
    return data;
  },
  async getRequestStatusGroupList(objectKey) {
    const data = await http.get(dataProvider.baseUrl + "/requeststatusgroups?" + objectKey);
    return data;
  },
  async createBulkRequestStatusGroups(item) {
    return await http.post(dataProvider.baseUrl + "/requeststatusgroups/createbulk", item);
  },
  async updateBulkRequestStatusGroups(item) {
    return await http.post(dataProvider.baseUrl + "/requeststatusgroups/updatebulk", item);
  },
  async GetOrderDetailByRefNo(objectKey) {
    const data = await http.get(dataProvider.baseUrl + "/requestordersexcusables/getorderdetail?" + objectKey);
    return data;
  },
  async postRequestExcusable(item) {
    const data = await http.post(dataProvider.baseUrl + "/requestorderexcusables", item);
    return data;
  },
  async postRequestExcusableFile(item) {
    const data = await http.post(dataProvider.baseUrl + "/requestorderexcusablehistoryfilerelations", item);
    return data;
  },
  async postRequestExcusableHistory(item) {
    const data = await http.post(dataProvider.baseUrl + "/requestorderexcusablehistorys", item);
    return data;
  },
  async deleteRequestExcusable(id: number) {
    const data = await http.delete(dataProvider.baseUrl + `/requestorderexcusables/${id}`);
    return data;
  },
  async postShippingAddress(item) {
    const data = await http.post(dataProvider.baseUrl + "/shippingaddresss", item);
    return data;
  },
  async createBulkAbilityControl(item) {
    return await http.post(dataProvider.baseUrl + "/abilitycontrols/createbulk", item);
  },
  async postAbilityControl(item) {
    const data = await http.post(dataProvider.baseUrl + "/abilitycontrols", item);
    return data;
  },
  async deleteAbilityControl(id) {
    return await http.delete(dataProvider.baseUrl + "/abilitycontrols/" + id);
  },
  async getDocumentsByRoNumber(id, wo) {
    const data = await http.get(dataProvider.baseUrl + "/vwshopReportdocuments/" + id + "/" + wo);
    return data;
  },
  async postShopReportFile(item) {
    const data = await http.post(dataProvider.baseUrl + "/shopreportfiles", item);
    return data;
  },
  async deleteShopReportFile(id) {
    return await http.delete(dataProvider.baseUrl + "/shopreportfiles/" + id);
  },
  async deleteFileRelation(id, source) {
    return await http.delete(dataProvider.baseUrl + "/" + source + "/" + id);
  },
  async uploadFileMinio(file: File) {
    const formData = new FormData();
    formData.append("file", file);
    return await http.post(dataProvider.baseUrl + "/minio", formData);
  },
  async getShopReportPdfHtml(wo) {
    return await http.get(dataProvider.baseUrl + "/shopreportpdf/" + wo);
  },
  async getMatbaaBlobData(html: string) {
    return await http.post<Blob>(dataProvider.baseUrl + "/matbaa/generate-pdf-simple", html, {
      headers: {
        "Content-Type": "application/json",
      },
      responseType: "blob",
    });
  },
  async getHealthCheck() {
    return await http.get(dataProvider.baseUrl.slice(0, -3) + "healthcheck");
  },
  async getHomeBaseQtyInfo(model) {
    return await http.post(dataProvider.baseUrl + "/" + "homebasecomponents/getqtyinfo", model);
  },
  async getHomeBaseQtyInfoForList(model) {
    return await http.post(dataProvider.baseUrl + "/" + "homebasecomponents/getqtyinfoforlist", model);
  },
  async createHomeBaseComponent(model) {
    return await http.post(dataProvider.baseUrl + "/" + "homebasecomponents", model);
  },
  async updateHomeBaseComponent(model) {
    return await http.put(dataProvider.baseUrl + "/" + "homebasecomponents", model);
  },
  async getHomeBaseComponent(id) {
    return await http.get(dataProvider.baseUrl + "/" + "homebasecomponents/" + id);
  },
  async postHomebaseComponentBulkCreate(model) {
    return await http.post(dataProvider.baseUrl + "/" + "homebasecomponents/bulkcreate", model);
  },
  async postHomebaseComponentTempCreate(model) {
    return await http.post(dataProvider.baseUrl + "/" + "homebasecomponents/bulktempcreate", model);
  },
  async updatePbhReserve(item) {
    return await http.put(dataProvider.baseUrl + "/pbhrequestreserves", item);
  },
  async postPbhReserve(item) {
    return await http.post(dataProvider.baseUrl + "/pbhrequestreserves", item);
  },
  async updateRbhReserve(item) {
    return await http.put(dataProvider.baseUrl + "/requestreserves", item);
  },
  async postRbhReserve(item) {
    return await http.post(dataProvider.baseUrl + "/requestreserves", item);
  },
  async getAircraftListByOwnerCode(ownerCode) {
    return await http.get(dataProvider.baseUrl + "/" + "cdmaircraft/" + ownerCode);
  },
  async postBulkAircraftUnderMaintenances(item) {
    return await http.post(dataProvider.baseUrl + "/aircraftundermaintenances/BulkInsert", item);
  },
  async postAircraftUnderMaintenances(item) {
    return await http.post(dataProvider.baseUrl + "/aircraftundermaintenances", item);
  },
  async putAircraftUnderMaintenances(item) {
    return await http.put(dataProvider.baseUrl + "/aircraftundermaintenances", item);
  },
  async getPbhRejectionOrder(unserviceablePn, unserviceableSn) {
    const data = await http.get(
      dataProvider.baseUrl + "/pbhrequestorders/checkrejectionorder/" + unserviceablePn + "/" + unserviceableSn
    );
    return data;
  },

  async postReliabilityReport(item) {
    const data = await http.post(dataProvider.baseUrl + "/reliabilityreports", item);
    return data;
  },

  async putReliabilityReport(item) {
    const data = await http.put(dataProvider.baseUrl + "/reliabilityreports", item);
    return data;
  },

  async postReliabilityReportRemark(item) {
    const data = await http.post(dataProvider.baseUrl + "/reliabilityreportremarks", item);
    return data;
  },
  async putReliabilityReportRemark(item) {
    const data = await http.put(dataProvider.baseUrl + "/reliabilityreportremarks", item);
    return data;
  },

  async postReliabilityFailOnFit(item) {
    const data = await http.post(dataProvider.baseUrl + "/reliabilityfailonfits", item);
    return data;
  },

  async putReliabilityFailOnFit(item) {
    const data = await http.put(dataProvider.baseUrl + "/reliabilityfailonfits", item);
    return data;
  },

  async putCustomerUserByRegisterId(ownerCode) {
    const data = await http.put(dataProvider.baseUrl + "/customerusers/updatecustomeruserbyregisterid", {
      ownerCode: ownerCode,
    });
    return data;
  },
  async getWhInfoByPn(objectKey) {
    const data = await http.get(dataProvider.baseUrl + "/pbhrequestorders/getwhinfobypn?" + objectKey);
    return data;
  },

  async postReliabilityExclusionPn(item) {
    const data = await http.post(dataProvider.baseUrl + "/reliabilityexclusionpns", item);
    return data;
  },

  async putReliabilityExclusionPn(item) {
    const data = await http.put(dataProvider.baseUrl + "/reliabilityexclusionpns", item);
    return data;
  },

  async postNffReportExclusionPn(item) {
    const data = await http.post(dataProvider.baseUrl + "/reliabilitynffexclusionpns", item);
    return data;
  },

  async putNffReportExclusionPn(item) {
    const data = await http.put(dataProvider.baseUrl + "/reliabilitynffexclusionpns", item);
    return data;
  },

  async postReliabilityThyFailOnFit(item) {
    const data = await http.post(dataProvider.baseUrl + "/reliabilitythyfailonfits", item);
    return data;
  },

  async putReliabilityThyFailOnFit(item) {
    const data = await http.put(dataProvider.baseUrl + "/reliabilitythyfailonfits", item);
    return data;
  },

  async postReliabilityPrematureFailure(item) {
    const data = await http.post(dataProvider.baseUrl + "/reliabilityprematurefailures", item);
    return data;
  },

  async putReliabilityPrematureFailure(item) {
    const data = await http.put(dataProvider.baseUrl + "/reliabilityprematurefailures", item);
    return data;
  },

  async postReliabilityThyPrematureFailure(item) {
    const data = await http.post(dataProvider.baseUrl + "/reliabilitythyprematurefailures", item);
    return data;
  },

  async putReliabilityThyPrematureFailure(item) {
    const data = await http.put(dataProvider.baseUrl + "/reliabilitythyprematurefailures", item);
    return data;
  },

  async getRedisKeys() {
    const data = await http.get(dataProvider.baseUrl + "/redis/getallkeys");
    return data;
  },

  async clearCacheWithKey(key) {
    await http.get(dataProvider.baseUrl + "/redis/clearwithkey/" + key);
  },

  async clearAllCache() {
    await http.get(dataProvider.baseUrl + "/redis/clearall");
  },

  async postAircraftUtilizationBulkCreate(model) {
    return await http.post(dataProvider.baseUrl + "/" + "aircraftutilizations/bulkcreate", model);
  },

  async postAircraftUtilizationTempCreate(model) {
    return await http.post(dataProvider.baseUrl + "/" + "aircraftutilizations/bulktempcreate", model);
  },

  async postReliabilityRogue(item) {
    const data = await http.post(dataProvider.baseUrl + "/reliabilityrogues", item);
    return data;
  },

  async putReliabilityRogue(item) {
    const data = await http.put(dataProvider.baseUrl + "/reliabilityrogues", item);
    return data;
  },

  async getReliabilityOtherConditions(goodsRcvdBatch) {
    return await http.get(dataProvider.baseUrl + "/reliabilityreports/otherreliabilityconditions/" + goodsRcvdBatch);
  },

  async getCoreInfoRequestByRefNo(refNo) {
    const data = await http.get(dataProvider.baseUrl + "/pbhrequestorders/coreinforequest/" + refNo);
    return data;
  },

  async downloadOldDataFile(fileName) {
    const data = await http.get(
      dataProvider.baseUrl + `/masterfiles/download?filename=${encodeURIComponent(fileName)}`,
      { responseType: "blob" }
    );
    return data;
  },

  async postAiAssistantSummary(payload: { pageName: string; filterParams: Record<string, any> }) {
    const data = await http.post(dataProvider.baseUrl + "/ai/assistant", payload);
    return data;
  },
};

export default appDataProvider;
export type AppDataProvider = typeof appDataProvider;
export const useAppDataProvider = (): AppDataProvider => useDataProvider() as any;
